import React from 'react';
import Button, { SpinnerSize } from '@jbhi-fi/lanyard-ui/components/Button/Button';
import { styles } from './WishlistButton.css';
import { classNames } from '@jbhi-fi/lanyard-ui/global/utils';
import HeartMinus from '@jbhi-fi/lanyard-ui/components/Icons/HeartMinus';
import HeartIcon from '@jbhi-fi/lanyard-ui/components/Icons/Heart';
import HeartEmptyIcon from '@jbhi-fi/lanyard-ui/components/Icons/HeartEmpty';

export type WishlistButtonState = 'default' | 'loading' | 'added';

export type WishlistButtonProps = {
  isLoading: boolean;
  state?: WishlistButtonState;
  type?: 'primary' | 'iconOnly' | 'secondary';
  iconSize?: 'sm' | 'lg';
  fullWidth?: boolean;
  className?: string;
  onClick: (e?: any) => void;
  testId?: string;
  useShortLabel?: boolean;
};

export const WishlistButton = ({
  state,
  type = 'secondary',
  isLoading,
  iconSize = 'lg',
  fullWidth,
  onClick,
  className,
  testId,
  useShortLabel,
}: WishlistButtonProps) => {
  const wishlistLabelPrefix = state === 'added' ? 'Remove from' : 'Add to';
  const wishlistLabel = `${useShortLabel ? 'Wishlist' : `${wishlistLabelPrefix} wishlist`}`;
  const getIcon = () => {
    if (state === 'added') {
      return (
        <div className={styles.iconContainer({ isIconOnly: type === 'iconOnly' })}>
          <HeartMinus
            className={classNames(
              styles.icon({ size: iconSize, type: 'remove' }),
              styles.button({ isAdded: state === 'added' })
            )}
          />
          <HeartIcon
            className={classNames(styles.icon({ size: iconSize }), styles.button({ isAdded: state === 'added' }))}
          />
        </div>
      );
    }
    return <HeartEmptyIcon className={styles.icon({ size: iconSize })} />;
  };
  return (
    <Button
      data-testid={testId}
      data-icon={state === 'added' ? 'added' : 'toAdd'}
      classes={classNames(
        className,
        styles.button({ isAdded: state === 'added', hasLabel: !fullWidth, isIconOnly: type === 'iconOnly' })
      )}
      title={`${wishlistLabelPrefix} wishlist`}
      label={fullWidth ? wishlistLabel : ''}
      iconPosition="left"
      type={type}
      icon={getIcon()}
      loading={isLoading}
      onClick={onClick}
      fullWidth={fullWidth}
      spinnerSize={iconSize === 'sm' ? SpinnerSize.xs : fullWidth ? SpinnerSize.default : SpinnerSize.small}
    />
  );
};
